module.exports = __webpack_public_path__ + "img/down_gray.0da09c78.svg";